import React, { Component } from 'react';

import api from '../../api/';

import { Col } from 'reactstrap';

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import ModalHistorico from "./ModalHistorico.js"

import ParadigmaTable from "../../components/ParadigmaTable/"
import dateFunctions from '../functions/dateFunctions';

class Presupuesto extends Component {
    constructor() {
        super();
        this.state = {
            filter: [{ 'id': 'plan__solicitud__fechaHistorico', 'value': {input: moment().subtract(1, 'year').format('YYYY')+'-01-01', lookup: "icontains" }}],
            columns: [
                {
                    Header: "id",
                    id: "plan__solicitud_id",
                    accessor: "plan__solicitud_id",
                    width: 70,
                    show: false,
                    private: true,
                },
                {
                    Header: "plan__solicitud__codigo",
                    id: "plan__solicitud__codigo",
                    // width: 150,
                    accessor:"plan__solicitud__codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.plan__solicitud__codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "Fecha",
                    id: "plan__solicitud__fecha",
                    width: 150,
                    accessor: d => dateFunctions.parseDateTime(d.plan__solicitud__fecha),
                    show: true,
                },
                {
                    Header: "Titulo",
                    id: "plan__solicitud__nombre",
                    accessor:"plan__solicitud__nombre",
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "plan__solicitud__observaciones",
                    accessor:"plan__solicitud__observaciones",
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "fullname",
                    accessor:"fullname",
                    show: true,
                },
                /*{
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 70,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.plan__solicitud__codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "ID SOLICITUD",
                    id: "plan__solicitud_id",
                    accessor: "plan__solicitud_id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Código Interno",
                    id: "plan__solicitud__codigo",
                    accessor: "plan__solicitud__codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Nombre",
                    id: "plan__solicitud__nombre",
                    accessor: "plan__solicitud__nombre",
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "plan__solicitud__empresa__nombre",
                    accessor: d => d.plan__solicitud__empresa__nombre,
                    show: true,
                },
                {
                    Header: "OTT",
                    id: "ott__nombre",
                    accessor: d => d.ott__nombre,
                    show: true,
                },
                {
                    Header: "UVT",
                    id: "uvt__nombre",
                    accessor: d => d.uvt__nombre,
                    show: true,
                },
                {
                    Header: "Valor Final",
                    id: "valorfinal",
                    accessor: d => d.valorfinal,
                    className: "text-right",
                    show: true,
                },
                {
                    Header: "Moneda",
                    id: "condiciondepago__nombre",
                    accessor: "condiciondepago__nombre",
                    width: 80,
                    show: true,
                },
                {
                    Header: "LTE",
                    id: "lae_full",
                    accessor: d => d.lae_full,
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "observaciones",
                    accessor: d => d.observaciones,
                    show: true,
                },
                {
                    Header: "hash_r",
                    id: "hash_r",
                    accessor: d => d.hash_r,
                    show: false,
                    private:true,
                },
                {
                    Header: "Reporte",
                    id: "reportable",
                    filterable: false,
                    accessor: d => (d.reportable ? api.proyectos.presupuesto.reporte + d.hash_r + "/" : ""),
                    show: true,
                    Cell: props => (props.value != '' ? <a target={"_blank"} href={props.value}>DESCARGAR</a> : ''),
                    width: 100,
                },
                {
                    Header: "fechaEnviadoUVT",
                    id: "fechaEnviadoUVT",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEnviadoUVT),
                    show: false,
                    private: true
                },
                {
                    Header: "fechaEnviadoOTT",
                    id: "fechaEnviadoOTT",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEnviadoOTT),
                    show: false,
                    private: true
                },
                {
                    Header: "FechaEstado",
                    id: "fechaEstado",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEstado),
                    show: false,
                    private: true
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    show: true,
                    className: "text-center",
                    width: 200,
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="PRESUPUESTANDO">PRESUPUESTANDO</option>
                            <option value="PRESUPUESTO RECHAZADO">PRESUPUESTO RECHAZADO</option>
                            <option value="PRESUPUESTO ACEPTADO">PRESUPUESTO ACEPTADO</option>
                            <option value="PRESUPUESTO ENVIADO">PRESUPUESTO ENVIADO</option>
                        </select>,
                    accessor: d => {
                        if (d.strestado == "PRESUPUESTANDO")
                            return (<div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                        else if (d.strestado == "PRESUPUESTO ACEPTADO")
                            return (<div className="badge badge-success presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                        else if (d.strestado == "PRESUPUESTO RECHAZADO")
                            return (<div className="badge badge-danger presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                        else
                            return (<div className="badge badge-primary presupuestoStateLabel">{d.strestado}
                                <br></br> <small>{dateFunctions.parseDateTime(d.strestado.indexOf('OTT') == -1 ? d.fechaEnviadoUVT : d.fechaEnviadoOTT)}</small>
                            </div>);
                    },
                },*/
            ]
        };
    }

    onChangeFecha(data) {
        let filter = [];
        if(typeof(data)!='string'){
            filter.push({ 'id': 'plan__solicitud__fechaHistorico', 'value': {input: data.format('YYYY')+'-01-01', lookup: "icontains" }});
        }
        this.setState({filter: filter });
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        createmultiSelect: true,
                        permission: 'historico_edit',
                        component: ModalHistorico,
                    },
                ]}

                apiUrl={api.proyectos.presupuesto.listhitoricos}
                columns={this.state.columns}
                exportUrl={api.proyectos.presupuesto.export}
                title={"Proyectos Historicos"}
                multiSelect={true}
                selectAll={true}
                outerFilter={this.state.filter}
                customSearchElement={(
                    <Col className={"mimicTableHeader ui-form pb-1 pt-1"}>
                        <section className="ui-section-block">
                            <div className="ui-row-1">
                                <div className="ui-field ui-field-compact">
                                    <label>Año</label>
                                    <Datetime
                                        className="input-year"
                                        dateFormat="YYYY"
                                        defaultValue={moment().subtract(1, 'year')}
                                        inputProps={{ maxLength: 4 }}
                                        closeOnSelect={true}
                                        onChange={(data) => this.onChangeFecha(data)}
                                    />
                                </div>
                            </div>
                        </section>
                    </Col>
                )}
            />
        );
    }
}

export default Presupuesto;



// WEBPACK FOOTER //
// ./src/views/ProyectosHistoricos/ProyectosHistoricos.js